export const RefundSettingsLanguage = {
  SettingForm: {
    DisplaySettingsText: "Display Settings",
    RefundSettingsText: "Refund Settings",
    RefundPolicyText: "Select Refund policy",
    RefundSubHeading: "To display to your attendees on your event listing.",
    FormLabal: {
      DisplaySettings: {
        labelHtml:
          "Display number of tickets remaining <span>The number of tickets remaining will be displayed to attendees.</span>",
        placeholder: "",
      },
    },
  },
  DanzfloRefundPolicy: "DanzFlo’s refund policy:",
  DanzfloRefundPolicyText:
    "You can issue your buyer a refund, but fee is nonrefundable and won’t be included.",
  LeanMoreText: "Learn More",
  PromoterSetting: "Promoter Commission",
  ServiceFeeSetting: "Service Fee (%)*",
  AllowSplitPaymentSetting: "Allow Split Payments*",
};

export const InstructionLanguage = {
  InstructionForm: {
    InstructionsText: "Instructions for Users",
    FormLabal: {
      Instructions: { label: "Title", placeholder: "" },
      DisplayMessage: {
        label: "Write comma separated instructions",
        placeholder: "Write your instructions here",
      },
    },
  },
};

export const EmailSmsLanguage = {
  EmailSmsHeading: "Emails to Attendees",
  EmailSmsForm: {
    CustomizeEmailText: "Customize Email",
    CustomizeEmailDesc:
      "Your attendees will also receive a reminder email prior to the event. Add important instructions or other useful information here to be included in the email.",
    FormLabal: {
      Instructions: { label: "Instructions", placeholder: "" },
      DisplayMessage: {
        label: "Display message (after ticket sales end)",
        placeholder: "",
      },
    },
  },
};
